import { fetchFeeForAmount } from 'lib/fee';
import ActivityRecipient from 'entities/ActivityRecipient';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import EncryptionNotice from 'components/EncryptionNotice.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import trackView from 'lib/trackView';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Money from 'payments/components/Money.jsx';
import Activity from 'entities/Activity';
import React from 'react';
import Receipt from './Receipt.jsx';
import ReceiptBody from './ReceiptBody.jsx';
import ReceiptFooter from './ReceiptFooter.jsx';
import ReceiptRow from './ReceiptRow.jsx';
import ToastActions from 'actions/ToastActions';
import TransactionActions from 'payments/actions/TransactionActions';
import withoutPaymentHeader from 'payments/utils/withoutPaymentHeader';

import './styles/PaymentChargeCreator.scss';

const CARD_ERRORS = ['card_declined', 'incorrect_cvc', 'expired_card'];

const PaymentChargeCreator = React.createClass({
  propTypes: {
    amount: React.PropTypes.number.isRequired,
    token: React.PropTypes.string.isRequired,
    onCardErrored: React.PropTypes.func,
    onTransactionCreated: React.PropTypes.func.isRequired,
    request: React.PropTypes.instanceOf(Activity).isRequired,
    recipient: React.PropTypes.instanceOf(ActivityRecipient).isRequired,
  },

  getInitialState() {
    return {
      processingSubmit: false,
      fee: null,
      feeError: null,
    };
  },

  componentDidMount() {
    this.fetchFee();
  },

  onTransactionCreateError(response) {
    const cardErrors = response['field_errors'].reduce((acc, error) => {
      if (CARD_ERRORS.includes(error.code)) {
        acc.push(error);
      }

      return acc;
    }, []);

    if (cardErrors.length > 0) {
      // this will trigger the parent comp to show the
      // card form again with the appropriate error message.
      this.props.onCardErrored(cardErrors);
    }

    ToastActions.showErrorToast('An error occured during the payment process');
  },

  fetchFee() {
    fetchFeeForAmount(this.props.amount)
      .then(fee => {
        this.setState({ fee, feeError: null });
      })
      .catch(feeError => {
        ToastActions.showAPIError(feeError);
        this.setState({ feeError });
        throw feeError;
      });
  },

  createTransaction() {
    this.setState({ processingSubmit: true });
    const onDone = () => {
      if (this.isMounted()) {
        this.setState({ processingSubmit: false });
      }
    };

    TransactionActions.pay(
      this.props.request.id,
      this.props.recipient.getNote(),
      this.props.amount,
      this.props.token,
      this.props.recipient.getAddress(),
      this.props.recipient.getName(),
      this.props.recipient.id,
    ).then(
      this.props.onTransactionCreated,
      this.onTransactionCreateError
    ).then(onDone, onDone);
  },

  render() {
    const { fee, feeError } = this.state;

    if (feeError) {
      return (
        <div className="PaymentChargeCreator">
          <p>An error occurred and your payment wasn’t processed.</p>
          <Button
            size="xsmall"
            className="PaymentChargeCreator-retry"
            onClick={this.fetchFee}
            eventElementName="PaymentChargeCreator-retry">
            Try again
          </Button>
        </div>
      );
    }

    if (!fee) {
      return (
        <div className="PaymentChargeCreator">
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="PaymentChargeCreator" data-test-selector="payment_charge_creator">
        <Container size="small">
          <h1 className="PaymentChargeCreator-title">
            Review and confirm your payment!
          </h1>
          <Receipt className="PaymentChargeCreator-confirmation">
            <ReceiptBody>
              <ReceiptRow>
                {this.props.request.getTitle()}
                <Money cents={this.props.amount} />
              </ReceiptRow>
              <ReceiptRow>
                <span>Service fee</span>
                <Money cents={fee} />
              </ReceiptRow>
            </ReceiptBody>
            <ReceiptFooter>
              <ReceiptRow className="PaymentChargeCreator-total">
                <span>Total payment</span>
                <Money cents={this.props.amount + fee} />
              </ReceiptRow>
            </ReceiptFooter>
          </Receipt>

          <Button
            data-test-selector="payment_charget_creator_submit"
            loading={this.state.processingSubmit}
            onClick={this.createTransaction}
            eventScreenName={EventTrackingConstants.CONFIRM_PAYMENT}
            eventElementName="pay">
            Pay
          </Button>
          <EncryptionNotice />
        </Container>
      </div>
    );
  },
});

export default trackView(withoutPaymentHeader(PaymentChargeCreator));



// WEBPACK FOOTER //
// ./src/payments/components/PaymentChargeCreator.jsx